class labels {
  static address = "Adresse";
  static citizens = "Borgere";
  static citizen = "Borger";
  static visit = "Besøg";
  static visitHours = "Besøgstid";
  static visitDetails = "Besøgdetaljer";
  static employees = "Medarbejdere";
  static employee = "Medarbejder";
  static minutes = "Minutter";
  static hours = "Timer";
  static details = "Detaljer";
  static dependencies = "Afhængigheder";
  static task = "Ydelse";
  static tasks = "Ydelser";
  static priority = "Prioritet";
  static citizenDetails = "Borgerdetaljer";
  static skillRequirement = "Kompetencekrav";
  static skills = "Kompetencer";
  static time = "Tid";
  static expenses = "Omkostninger";
  static keyNumbers = "Andre nøgletal";
  static citizenService = "Borgerservice";
  static plannedTime = "Planlagt tid";
  static plannedEmployees = "Planlagte medarbejdere";
  static unplannedEmployees = "Uplanlagte medarbejdere";
  static timeWithCitizens = "Borgertid";
  static otherTasks = "Andre kalenderaftaler";
  static transportation = "Kørsel";
  static plan = "Vagtplan";
  static overtime = "Overtid";
  static unplannedTime = "Uplanlagt tid";
  static affinity = "Kontinuitet";
  static filter = "Filtre";
  static AIMissing = "AI planlægning mangler";
  static AICompleted = "AI planlægning er færdig";
  static search = "Søg";
  static choosePeriod = "Vælg periode";
  static locked = "Låst på medarbejder";
  static nexusRules = "Regler fra Nexus";
  static blocked = "Borger undtaget fra kontakt";
  static score = "Score";
  static rules = "Regler";
  static competencies = "Kompetencer";
  static assignedEmployee = "Tildelt medarbejder";
  static preferences = "Præferencer";
  static high = "Høj";
  static normal = "Normal";
  static searchPrompt = "Søg borger eller ydelse";
  static compareWithNexus = "Sammenlign med original";
  static error = "Fejlkode"

  // Task Dependencies
  static isDependencyOfTitle = "Besøget har følgende tilknyttede besøg";
  static dependsOnTitle = "Besøget er tilknyttet følgende primære besøg";
  static startTimeColumnLabel = "Opstart";
  static endTimeColumnLabel = "Slut";

  // Violations
  static violation = "Regelbrud";
  static unplannedTask = "Uplanlagt";
  static violationSkill =
    "Medarbejderen opfylder ikke alle kompetencekrav på opgaven";
  static violationDependency = "En tids sammenkædning er ikke overholdt";
  static violationDependencyUnplanned = "Et sammenkædet besøg er uplanlagt";
  static violationDependencySameEmployee =
    "En samme medarbejder sammenkædning er ikke overholdt";
  static violationDependencyTime =
    "En tidsmæssig sammenkædning er ikke overholdt";
  static violationOverdue =
    "Opgavens start- eller sluttidspunkt er uden for det tilladte tidsvindue";
  static violationOvertime = "Medarbejderen har for mange timer";
  static violationTravelTotalDistance =
    "Medarbejderen har for lang transport over hele dagen";
  static violationTravelTripDistance =
    "Medarbejderen har for lang transport på en enkelt tur";
  static violationTravelFirstLastTripDistance =
    "Medarbejderen har for lang transport på første eller sidste tur";
  static violationOfTotalTravelDistance =
    "Den samlede distance, som medarbejderen har rejst, overstiger den tilladte grænse.";
  static violationOfTravelTripDistance =
    "Afstanden, som medarbejderen har rejst på en enkelt tur, overstiger den tilladte grænse.";
  static violationOfFirstLastTripDistance =
    "Afstanden, som medarbejderen har rejst på den første eller sidste tur, overstiger den tilladte grænse.";
  static violationBlockedEmployee =
    "Borgeren er undtaget fra kontakt ved den planlagte medarbejder";
  static violationNoEmployeeWithNecessarySkill =
    "Ingen medarbejdere havde de nødvendige kompetencer.";
  static violationTaskInvalidTimeWindow =
    "Det tilladte planlægningsinterval er for kort i forhold til opgavens varighed.";
  static violationTaskInvalidLinkedTaskDuration =
    "To sammenkædede besøg kan ikke begge planlægges indenfor deres tilladte planlægningsinterval.";
  static violationValidationCircularReference =
    "En sammenkædning er ugyldig da besøgenes rækkefølge ikke kan afgøres.";
  static violationTaskTooLateStartComparedToEmployees =
    "Det tilladte planlægningsinterval starter for sent til at en medarbejder kan tage besøget.";
  static violationTaskTooEarlyStartComparedToEmployees =
    "Det tilladte planlægningsinterval slutter for tidligt til at en medarbejder kan tage besøget.";
  static violationTaskTooEarlyStartComparedToLockedEmployee =
    "Besøget er låst på medarbejder som ikke har arbejdstid indenfor besøgets tilladte planlægningsinterval.";
  static violationTaskTooLateStartComparedToLockedEmployee =
    "Besøget er låst på medarbejder som ikke har arbejdstid indenfor besøgets tilladte planlægningsinterval.";
  static violationNoEmployees =
    "Der er ikke nogen medarbejdere med  arbejdstid i det tilladte planlægningsinterval.";
  static violationTaskExpandedTimeWindowNotEnclosePreferredTimeWindow =
    "Foretrukket starttidspunkt er ændret af systemet, da det lå uden for det tilladte planlægningsinterval.";
  static violationTasksInvalidMinOrMaxDuration =
    "Tilladt tidsvindue ikke overholdt.";
  static violationEmployeesNotWorking =
    "Dette besøg er låst til en medarbejder som ikke har arbejdstid i dag.";

  // Violation messages
  static unspecifiedViolationMessage =
    "En uspecificeret regel er ikke blevet overholdt.";
  static dependencyMinOverlapViolationMessage = (minutes: string) =>
    `Besøgene skal overlappe med mindst ${minutes} minutter.`;
  static sameEmployeeViolationMessage =
    "Besøgene skal udføres af samme medarbejder.";
  static maxDelayTimeViolationMessage = (
    minutes: string,
    anchor: "START" | "END",
  ) =>
    `Det tilknyttede besøg skal starte højest ${minutes} minutter efter det primære besøg ${anchor === "END" ? "slutter" : "starter"}.`;
  static minDelayTimeViolationMessage = (
    minutes: string,
    anchor: "START" | "END",
  ) =>
    `Det tilknyttede besøg skal starte mindst ${minutes} minutter efter det primære besøg ${anchor === "END" ? "slutter" : "starter"}.`;
  static sameStartViolationMessage = "Besøgene skal starte samtidigt.";
  static startRightAfterViolationMessage =
    "Det tilknyttede besøg skal starte umiddelbart efter det primære besøg.";
  // buttons
  static sinceNexusData = "Siden Nexus-data";
  static sendNexusData = "Send plan til Nexus";
  static UpdatePlan = "Opdater planlægning";
  static undo = "Fortryd";

  // login page
  static login = "Log ind";

  static hoverEmployee = "Medarbejder";
  static hoverTasks = "Ydelser";

  static pondooCompleted = (duration: string) => {
    return `Pondoo plan opdateret ${duration} siden`;
  };
  static pondooNotUpdated = "Pondoo plan ikke opdateret";
  static pondooMissing = "Pondoo plan mangler";
  static pondooStatusError = "Pondoo plan fejlede";
  static pondooStatusAborted = "Pondoo plan blev afbrudt";
  static pondooStatusCalculating = "Beregner...";
  static pondooNexusLandingError = "Noget gik galt - var der data på filteret?";
  static pondooRunning = "Kører...";
  static tryAgain = "Prøv igen";
  static update = "Opdater";

  static nexusLandingDataAlreadyExistsWarningHeader = "Er du sikker?";
  static nexusLandingDataAlreadyExistsWarningBody =
    "Der er allerede blevet hentet data fra Nexus for denne kalender og dato. Hvis du trykker videre herfra, vil eksisterende data i Pondoo blive overskrevet. Er du sikker på at du vil fortsætte?";
  static nexusLandingPageGoToExistingButton = "Gå til eksisterende plan";
  static nexusLandingPageOverwriteData = "Overskriv Pondoo data";
  static ganttChartLockErrorMessage =
    "Vi kunne ikke opdatere låsning af kalenderen for medarbejderen.";
  static ganttChartLockShiftWarningHeader = "Er du sikker?";
  static ganttChartLockShiftWarningBody =
    "Hvis du vælger at fortsætte, stoppes optimeringen. Vil du fortsætte?";
  static ganttChartLockShiftCancel = "Fortryd";
  static ganttChartLockShiftProceed = "Fortsæt";

  // Time units
  static dayAmount = (amount: number): string =>
    `${amount} ${amount === 1 ? "dag" : "dage"}`;
  static hoursAmount = (amount: number): string =>
    `${amount} ${amount === 1 ? "time" : "timer"}`;
  static minutesAmount = (amount: number): string =>
    `${amount} ${amount === 1 ? "minut" : "minutter"}`;
  static secondsAmount = (amount: number): string =>
    `${amount} ${amount === 1 ? "sekund" : "sekunder"}`;

  // Parameterized toast messages
  static stopOptimizationToastMessage = (date: string) =>
    `Optimering stoppet for dato: ${date}`;

  // Nexus Export Error Modal
  static nexusExportErrorHeader = "Fejl ved eksport til Nexus";
  static nexusExportErrorBody =
    "Der skete en fejl da planen skulle sendes til Nexus. De følgende besøg kunne ikke blive opdateret:";
  static nexusExportErrorClose = "Tilbage";
  static nexusExportErrorRetry = "Send til Nexus alligevel";
  static nexusExportUnknownTask = "Ukendt opgave";
  static nexusExportUnknownEmployee = "Ukendt medarbejder";
  static nexusExportErrorGeneral =
    "Der opstod en fejl under afsendelse til Nexus";
  static nexusExportPartialFailure =
    "Nogle opgaver kunne ikke sendes til Nexus";
  static nexusExportSuccess = "Planen blev sendt til Nexus";
  static nexusServerConnectionError = "Ingen forbindelse til serveren. Planen kunne ikke sendes til Nexus."

  // calendar settings
  static generalSettings = "Generelt";
  static skillProfiles = "Ydelsesprofiler";
  static addressSettingsInfo = "Adressen kan ændres i Nexus.";
  static addressSettings = "Standard start- og slut lokation";
  static startAddress = "Start adresse";
  static endAddress = "Slut adresse";
  static workTimeSettingsInfo =
    "Ved import af data fra Nexus ignoreres besøg, aftaler og arbejdstid som ligger uden for dette interval.";
  static workTimeSettings = "Standard planlægningsinterval";
  static startTime = "Starttid";
  static endTime = "Sluttid";
  static teamSettings = "Team indstillinger";
  static nexusTeamHex = "Nexus farvekode";
  static pondooTeamName = "Pondoo team navn";
  static groupEmployeesInTeams = "Gruppér alle medarbejdere med denne farve";
  static seeAll = "Vis alle";
  static noAddress = "Ingen adresse";
  static noTeams = "Ingen Nexus teams at vise";
  static noTeamsExplained =
    "Teams vil blive vist, når Pondoo modtager farvekoder med planen fra Nexus.";

  // employee drawer
  static employeeSettings = "Besøgsindstillinger"
  static citizenPreferences = "Borger præferencer"
  static dailySettings = "Daglig justering"
  static permanentSettings = "Permanent justering"
  static editWorkingHours = "Juster arbejdstid"
  static transport = "Transport"
  static addTransportType = "Tilføj transportmiddel"
  static transportType = "Transportmiddel"
  static chooseTransport = "Vælg transportmiddel"
  static startTimeTransport = "Starttidspunkt"
  static endTimeTransport = "Sluttidspunkt"
  static transportCar = "Bil"
  static transportBike = "Cykel"
  static transportElectricBike = "Elcykel"
  static transportWalking = "Gående"
  static errorEmptyFields = "Venligst udfyld alle felter"
  static errorOutsideWorkHours = "Transporttid ligger uden for arbejdstiden"
  static errorOverlappingTimeWindow = "Transporttiderne overlapper"
  static errorNotFilledWorkHours = "Transporttiden passer ikke med arbejdstiden"
  static save = "Gem"
  static discard = "Kassér"
  static manuallyEditedWorkTime = "Arbejdstiden er blevet manuelt ændret"
  static unsavedChanges = "Ugemte ændringer"
  static saveChangesWarningBody = "Vil du gemme dem før du fortsætter?"
  static discardAndCloseModal = "Kassér og fortsæt"
  static saveAndCloseModal = "Gem og fortsæt"

  //Drag and drop
  static endingDragAndDropSessionWaningText =
    "Alle manuelle tilrettelser vil blive slettet. Ønsker du at fortsætte? Dette vil ikke påvirke planen der er sendt til Nexus.";
  static endingDragAndDropSessionWaningHeader = "Slet tilpasset plan?";
  static deleteDragAndDropCustomPlan = "Slet planen";
  static returnToDragAndDropEdit = "Tilbage";

  //Drag and drop statusbar
  static calculatingTransportation = "Beregner transporttid";
  static violations = "Regelbrud";
  static saveChanges = "Gem ændringer";

}

export default labels;
